import { Badge, HStack, Icon } from "@chakra-ui/react";
import { X } from "lucide-react";
import { toDm } from "../../../../lib/weekRange";

/** Chip toggle "Apenas esta semana" para uma seção com filtro por período
 * (Concluídos, Cancelados).
 * - `active=true`  → mostra "(DD/MM–DD/MM)" com X (clica pra desligar).
 * - `active=false` → mostra o rótulo outline (clica pra reativar). */
export const WeekFilterChip = ({
  active,
  weekStart,
  weekEnd,
  onToggle,
  label = "Apenas esta semana",
  activeTitle = "Mostrar todos",
  inactiveTitle = "Filtrar apenas nesta semana",
}: {
  active: boolean;
  weekStart: Date;
  weekEnd: Date;
  onToggle: () => void;
  label?: string;
  activeTitle?: string;
  inactiveTitle?: string;
}) => {
  if (active) {
    return (
      <Badge
        as="button"
        colorScheme="blue"
        variant="subtle"
        borderRadius="full"
        px={2}
        py={0.5}
        fontSize="10px"
        fontWeight="600"
        textTransform="none"
        cursor="pointer"
        flexShrink={0}
        onClick={(e: React.MouseEvent) => { e.stopPropagation(); onToggle(); }}
        title={activeTitle}
      >
        <HStack spacing={1} align="center">
          <span>{toDm(weekStart)}–{toDm(weekEnd)}</span>
          <Icon as={X} boxSize={2.5} strokeWidth={2.5} />
        </HStack>
      </Badge>
    );
  }
  return (
    <Badge
      as="button"
      variant="outline"
      colorScheme="gray"
      borderRadius="full"
      px={2}
      py={0.5}
      fontSize="10px"
      fontWeight="600"
      textTransform="none"
      cursor="pointer"
      flexShrink={0}
      onClick={(e: React.MouseEvent) => { e.stopPropagation(); onToggle(); }}
      title={inactiveTitle}
    >
      {label}
    </Badge>
  );
};